import { render } from "./ModelPopup.vue?vue&type=template&id=f5a6e164"
import script from "./ModelPopup.vue?vue&type=script&lang=js"
export * from "./ModelPopup.vue?vue&type=script&lang=js"

import "./ModelPopup.vue?vue&type=style&index=0&id=f5a6e164&lang=css"

import exportComponent from "D:\\portfolio\\bhavindabhi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__